import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

function ResetButton({ children, disabled = false, ...props }) {
	return (
		<div {...props}>
			<Button
				variant="text"
				color="primary"
				size="large"
				disabled={disabled}
				role="button"
				data-testid="reset-button"
				aria-label="reset-button"
				startIcon={
					<RefreshIcon
						aria-label="refresh"
						aria-hidden="true"
						role="graphics-symbol"
					/>
				}
			>
				{children}
			</Button>
		</div>
	);
}

ResetButton.propTypes = {
	children: PropTypes.any.isRequired,
	disabled: PropTypes.bool,
};

export default ResetButton;
